import {
  LIST_SERVICE_CLASSIFICATION_REQUEST,
  LIST_SERVICE_CLASSIFICATION_SUCCESS,
  LIST_SERVICE_CLASSIFICATION_FAIL,
  LIST_SERVICE_CLASSIFICATION_SUMMARY_REQUEST,
  LIST_SERVICE_CLASSIFICATION_SUMMARY_SUCCESS,
  LIST_SERVICE_CLASSIFICATION_SUMMARY_FAIL,
  CREATE_SERVICE_CLASSIFICATION_REQUEST,
  CREATE_SERVICE_CLASSIFICATION_SUCCESS,
  CREATE_SERVICE_CLASSIFICATION_FAIL,
  UPDATE_SERVICE_CLASSIFICATION_REQUEST,
  UPDATE_SERVICE_CLASSIFICATION_SUCCESS,
  UPDATE_SERVICE_CLASSIFICATION_FAIL,
  DELETE_SERVICE_CLASSIFICATION_REQUEST,
  DELETE_SERVICE_CLASSIFICATION_SUCCESS,
  DELETE_SERVICE_CLASSIFICATION_FAIL,
  DETAIL_SERVICE_CLASSIFICATION_REQUEST,
  DETAIL_SERVICE_CLASSIFICATION_SUCCESS,
  DETAIL_SERVICE_CLASSIFICATION_FAIL
} from '../../constants/service-classifications'

const initialState = {
  loading: false,
  serviceClassifications: [],
  serviceClassificationsSummary: [],
  serviceClassification:{},
  pageable: {},
  loadingCreate: false,
  loadingDetail: false,
  loadingUpdate: false,
  error: null
}

const serviceClassificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_SERVICE_CLASSIFICATION_REQUEST:
      return {
        ...state,
        loading: true
      }
    case LIST_SERVICE_CLASSIFICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        serviceClassifications: action.payload,
        pageable: action.pageable
      }
    case LIST_SERVICE_CLASSIFICATION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        serviceClassifications: []
      }
    case LIST_SERVICE_CLASSIFICATION_SUMMARY_REQUEST:
      return {
        ...state,
        loading: true
      }
    case LIST_SERVICE_CLASSIFICATION_SUMMARY_SUCCESS:
      return {
        ...state,
        loading: false,
        serviceClassificationsSummary: action.payload
      }
    case LIST_SERVICE_CLASSIFICATION_SUMMARY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case CREATE_SERVICE_CLASSIFICATION_REQUEST:
      return {
        ...state,
        loadingCreate: true
      }
    case CREATE_SERVICE_CLASSIFICATION_SUCCESS:
      return {
        ...state,
        loadingCreate: false,
        serviceClassifications: [...state.serviceClassifications, action.payload]
      }
    case CREATE_SERVICE_CLASSIFICATION_FAIL:
      return {
        ...state,
        loadingCreate: false,
        error: action.payload
      }
    case DETAIL_SERVICE_CLASSIFICATION_REQUEST:
      return { ...state, loadingDetail: true, serviceClassification: {}}
    case DETAIL_SERVICE_CLASSIFICATION_SUCCESS:
      return { ...state, loadingDetail: false, serviceClassification: action.payload  }
    case DETAIL_SERVICE_CLASSIFICATION_FAIL:
      return { ...state, loadingDetail: false, error: action.payload, serviceClassification: {} }
    case UPDATE_SERVICE_CLASSIFICATION_REQUEST:
      return {
        ...state,
        loadingUpdate: true
      }
    case UPDATE_SERVICE_CLASSIFICATION_SUCCESS:
      const updatedServiceClassification = action.payload
      const updateFindIndexServiceClassification = state.serviceClassifications.findIndex(title => title.id === updatedServiceClassification.id)
      const updatedServiceClassifications = [...state.serviceClassifications]
      updatedServiceClassifications[updateFindIndexServiceClassification] = updatedServiceClassification

      return {
        ...state,
        loadingUpdate: false,
        serviceClassifications: updatedServiceClassifications
      }
    case UPDATE_SERVICE_CLASSIFICATION_FAIL:
      return {
        ...state,
        loadingUpdate: false,
        error: action.payload
      }
    case DELETE_SERVICE_CLASSIFICATION_REQUEST:
      return {
        ...state,
        loading: true
      }
    case DELETE_SERVICE_CLASSIFICATION_SUCCESS:
      const deletedServiceClassificationId = action.payload
      const deletedFindIndexServiceClassification = state.serviceClassifications.findIndex(title => title.id === deletedServiceClassificationId)
      const deletedServiceClassifications = [...state.serviceClassifications]
      deletedServiceClassifications.splice(deletedFindIndexServiceClassification, 1)

      return {
        ...state,
        loading: false,
        serviceClassifications: deletedServiceClassifications
      }
    case DELETE_SERVICE_CLASSIFICATION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    default:
      return state
  }
}

export default serviceClassificationReducer